const baseUrlFirstPart = 'https://console.eda';
const baseUrlSecondPart = '.data.arkemacloud.com/api/v0/';

function stringToHexColor(str: string = ""): string {
  let hash = 0;

  // Create a 32-bit hash
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }

  // Convert to unsigned and hex
  const hex = (hash >>> 0).toString(16).padStart(8, "0");

  // Format as #RRGGBBAA
  return `#${hex}`;
}

export function getApiBaseUrl() {
    const env = process.env.REACT_APP_ENV;
    switch (env) {
        case 'local':
            return "https://c0lo14rjnd.execute-api.eu-west-1.amazonaws.com/dev/api/v0/";
        case 'prod':
            return baseUrlFirstPart.concat(baseUrlSecondPart);
        default:
            return baseUrlFirstPart.concat(`.${env}`, baseUrlSecondPart);
    }
}

export function getHeaderColor() {
    const env = process.env.REACT_APP_ENV;
    switch (env) {
        case 'prod':
            return "#4269ffe6";
        case 'qual':
            return "#45818ee6";
        case 'dev':
            return "#00933ee6";
        default:
            return stringToHexColor(env);
    }
}

export function getHeaderTextColor() {
    const env = process.env.REACT_APP_ENV;
    switch (env) {
        case 'prod':
        case 'qual':
        case 'dev':
        default:
            return "#ffffff";
    }
}

export function getEnvLabel() {
    const env = process.env.REACT_APP_ENV;
    switch (env) {
        case 'prod':
            return "Prod";
        case 'qual':
            return "Qual";
        case 'dev':
            return "Dev";
        default:
            return env;
    }
}
